import styled from "styled-components";
import { Box, colors, darken } from "@mui/material";

export const AuthContainer = styled(Box)`
	width: 100%;
	//min-height: 100vh;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	margin-top: 150px;
	${props => props.theme.breakpoints.down("md")} {
		margin-top: 100px;
		height: unset;
	}
`;

export const AuthWrapper = styled(Box)`
	min-height: 500px;
	width: 70vw;
	display: flex;
	flex-flow: row wrap;
	box-shadow: 0 0 5px 2px ${colors.grey[300]};
	margin-top: 30px;
	/* Change the white to any color */
	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus,
	input:-webkit-autofill:active {
		-webkit-box-shadow: 0 0 0 30px #fff inset !important;
	}
	.left_block {
		background: ${colors.common.white};
		padding: 10px 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		flex-grow: 1;
		//flex-basis: 50%;
		.title {
			font-family: var(--openSans), sans-serif;
			font-weight: bold;
			font-size: 24px;
		}
		.input_wrapper {
			h6 {
				font-family: var(--openSans), sans-serif;
				font-weight: 500;
				margin-bottom: 5px;
			}
			p.Mui-error {
				max-width: 400px;
			}
		}
		.signBtn {
			border-radius: 30px;
			margin-top: 20px;
		}
	}
	.right_block {
		background: ${({ theme }) => theme.custom_palette.color1};
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		flex-grow: 1;
		padding: 20px;
		h4 {
			font-family: var(--openSans), sans-serif;
			color: ${colors.common.white};
			font-weight: bold;
		}
		h6 {
			font-family: var(--poppins), sans-serif;
			color: ${colors.common.white};
			margin-top: 20px;
		}
		button {
			margin-top: 20px;
			background: ${colors.common.white};
			color: ${colors.common.black};
			border-radius: 30px;
			&:hover {
				background: ${darken(colors.common.white, 0.1)};
			}
		}
	}

	${props => props.theme.breakpoints.down("lg")} {
		width: 90vw;
		margin-top: 0;

		.left_block {
			flex-basis: 100%;
		}
		.right_block {
			flex-basis: 100%;
			padding: 50px 10px;
		}
	}
`;
